import formatWithOptions from 'date-fns/fp/formatWithOptions';
import parseISO from 'date-fns/fp/parseISO';

// eslint-disable-next-line import/no-relative-packages
import { i18n } from '../../../../i18n';

import { locales, transformLanguageCode } from './locales';

export const DEFAULT_DATE_FORMAT = 'dd MMM yyyy';
const DEFAULT_LOCALE = 'en-GB';

export const formatDate = (
    date: string | undefined,
    locale?: string,
    format = DEFAULT_DATE_FORMAT
) => {
    if (!date) return '';
    const userLocale = locales[transformLanguageCode(locale || i18n?.language || DEFAULT_LOCALE)];
    return formatWithOptions({ locale: userLocale }, format, parseISO(date));
};
